// Generated by ReScript, PLEASE EDIT WITH CARE

import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Translation$Dashboard from "./Translation.res.js";

function Panel$Loading(props) {
  return JsxRuntime.jsxs("p", {
    children: [
      JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "spinner",
          spin: true
        }),
        className: "panel-icon"
      }),
      JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
        entry: "Loading"
      })
    ],
    className: "panel-block"
  });
}

let Loading = {
  make: Panel$Loading
};

export {
  Loading,
}
/* FontAwesome-Web Not a pure module */
